/**
 * Status eines Mitglieds/einer Mitgliedschaft
 */
export enum MemberStatus {
   /**
    * Mitgliedschaft angefragt.
    */
   requested = "requested",

   /**
    * Mitglied bestätigt und aktiv.
    */
   active = "active",

   /**
    * Mitgliedschaft gekündigt.
    */
   canceled = "canceled",

   /**
    * Mitgliedschaft beendet.
    */
   ended = "ended",
}

export const MemberStatusNames = {
   requested: "Angefragt",
   active: "Aktiv",
   canceled: "Gekündigt",
   ended: "Beendet"
};